<div>
  <!-- FULL VIEW -->
  @if (!collapsed) {
    <div class="container background px-3 px-md-5 py-5">
      <div class="row pb-3 gx-0">
        <div class="col-11 ps-0">
          <h1 class="text-start grey-color whitespace-preline">{{'homepage.direct-channel.intro.title' | translate}}</h1>
        </div>
        <div class="col pe-0">
          <div class="ms-auto pointer">
            <fa-icon [icon]="faChevronUp" (click)="collapsed = true" class="fa-xl pointer grey-color"></fa-icon>
          </div>
        </div>
      </div>
      <div class="row pb-2 gx-0">
        <div class="col-12 ps-0">
          <h3 class="text-start grey-color">{{'homepage.direct-channel.intro.subtitle' | translate}}</h3>
        </div>
      </div>
      <div class="row pb-2 gx-0">
        <div class="col-12 ps-0">
          <h5 class="text-start grey-color whitespace-preline">{{'homepage.direct-channel.intro.description' | translate}}
          </h5>
        </div>
      </div>
      <div class="start-now row gx-0">
        <div class="col ps-0">
          <button (click)="goToOrientationQuestionnaire()" [disabled]="redirecting || !canCreateReq"
            class="btn btn-primary btn-lg text-uppercase">
            {{'homepage.direct-channel.intro.start-now' | translate}}
            @if (redirecting) {
              <fa-icon [icon]="faCircleNotch" animation="spin" class="fill-white"></fa-icon>
            }
          </button>
        </div>
      </div>
    </div>
  }
  <!-- COLLAPSED VIEW -->
  @if (collapsed) {
    <div class="container background-collapsed px-3 px-md-5">
      <div class="row pb-3 gx-0">
        <div class="col-12">
          <h1 class="text-center collapsed-title grey-color">
            {{'homepage.direct-channel.intro.subtitle' | translate}}
            <button (click)="goToOrientationQuestionnaire()" [disabled]="redirecting || !canCreateReq"
              class="btn btn-primary btn-lg text-uppercase ms-3 fit-content">
              {{'homepage.direct-channel.intro.start-now' | translate}}
              @if (redirecting) {
                <fa-icon [icon]="faCircleNotch" animation="spin" class="fill-white"></fa-icon>
              }
            </button>
          </h1>
        </div>
      </div>
      <div class="d-flex justify-content-center">
        <div class="text-center" (click)="collapsed = false">
          <fa-icon [icon]="faChevronDown" class="fa-xl pointer grey-color"></fa-icon>
        </div>
      </div>
    </div>
  }
</div>
